import NotificationsEmail from '@/App/UserPreferences/Notifications/Emails/NotificationsEmail.tsx';
import SplitNotificationsEmailsCash from '@/App/UserPreferences/Notifications/Emails/SplitNotificationsEmailsCash.tsx';
import SplitNotificationsEmailsOptions from '@/App/UserPreferences/Notifications/Emails/SplitNotificationsEmailsOptions.tsx';
import SplitNotificationsEmailsOrders from '@/App/UserPreferences/Notifications/Emails/SplitNotificationsEmailsOrders.tsx';
import SplitNotifications from '@/App/UserPreferences/Notifications/SplitNotifications.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

export const NotificationsTab = () => {
  const userPreferences = useAppSelector(getUserPreferences);

  return (
    <div className="overflow-y-auto">
      <div className="border">
        <SplitNotifications />
      </div>

      {!userPreferences.splitNotifications ? (
        <NotificationsEmail />
      ) : (
        <>
          <SplitNotificationsEmailsCash />
          <SplitNotificationsEmailsOrders />
          <SplitNotificationsEmailsOptions />
        </>
      )}
    </div>
  );
};
